import { StorageFile, StorageFileFormDefault } from "api/model/StorageFile";

export interface Brand {
    id: string;
    name: string;
    image?: StorageFile;
}

export const BrandFormDefault: Brand = {
    id: "",
    name: "",
    image: StorageFileFormDefault,
};
